module.exports = __webpack_public_path__ + "static/payment_gateway-599d003e035f47f4f9edbd4eeb8d061c.svg";